import React from 'react';
import DataPlataformListPage from '../../Components/DataPlataformListPage';

const icons = {
    exercicio: <img src="/images/icons/calendar_search_black.svg" alt="Exercício" width={18} style={{ marginRight: 6 }} />,
    uf: <img src="/images/icons/point_on_map_black.svg" alt="UF" width={18} style={{ marginRight: 6 }} />,
    tipo: <img src="/images/icons/filter_black.svg" alt="Tipo" width={18} style={{ marginRight: 6 }} />,
    conta: <img src="/images/icons/magnifer_black.svg" alt="Conta" width={18} style={{ marginRight: 6 }} />,
    valor: <img src="/images/icons/dollar_minimalistic_black.svg" alt="Valor" width={18} style={{ marginRight: 6 }} />,
};

const columns = [
    { key: 'exercicio', label: 'Exercício', icon: icons.exercicio },
    { key: 'uf', label: 'UF', icon: icons.uf, align: 'center' },
    { key: 'tipo_receita', label: 'Tipo', icon: icons.tipo },
    { key: 'descricao_conta', label: 'Conta', icon: icons.conta },
    { key: 'valor', label: 'Valor', icon: icons.valor, align: 'right', format: v => Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }
];

const StateNetCurrentRevenue = () => (
    <DataPlataformListPage
        datasetKey="state-net-current-revenue"
        title="Receita Corrente Líquida dos Estados"
        iconLeft={<img src="/images/icons/city.svg" width="18" alt="Estados" />}
        label="ESTADOS"
        api={{
            search: `${process.env.REACT_APP_API_URL}/estado-rreo-an3`,
            grafico: `${process.env.REACT_APP_API_URL}/estado-rreo-an3-grafico`,
            exercicios: `${process.env.REACT_APP_API_URL}/estado-rreo-an3-exercicios`,
            contas: `${process.env.REACT_APP_API_URL}/estado-rreo-an3-filtro-conta`,
            ufs: `${process.env.REACT_APP_API_URL}/filtro-uf`,
            email: `${process.env.REACT_APP_API_URL}/estado-rreo-an3-email`,
        }}
        columns={columns}
    />
);

export default StateNetCurrentRevenue;